type ReturnResult = {
  returnUrl?: string | null;
  resultCode?: string | null;
  resultMsg?: string | null;
  transSeqno?: string | null;
  approvalAmount?: string | number | null;
  tempValue?: string | null;
};

/**
 * 결제 후 가맹점 복귀 주소(RETURN_URL)에 결과를 붙인다.
 * 가맹점 주소에 이미 있는 쿼리는 그대로 두고 값은 인코딩한다.
 * 고객 휴대폰 번호는 주소(브라우저 기록·서버 로그)에 남지 않도록 싣지 않는다.
 * 주소가 올바르지 않으면 null — 이동하지 않고 결과 화면에 머문다.
 */
export const buildReturnUrl = (result: ReturnResult): string | null => {
  if (!result.returnUrl) return null;
  let url: URL;
  try {
    url = new URL(result.returnUrl);
  } catch {
    return null;
  }
  const params: Array<[string, ReturnResult[keyof ReturnResult]]> = [
    ["RESULT_CODE", result.resultCode],
    ["RESULT_MSG", result.resultMsg],
    ["TRANS_SEQNO", result.transSeqno],
    ["APPROVAL_AMOUNT", result.approvalAmount],
    ["TEMP_VALUE", result.tempValue],
  ];
  params.forEach(([key, value]) => url.searchParams.set(key, value == null ? "" : String(value)));
  return url.toString();
};
